<div class="container">
  <div class="columns">
    <div class="column col-12 callout {{ callout.type }}">
      <h4 *ngIf="callout.title">{{ callout.title | translate }}</h4>
      <p *ngFor="let description of descriptions; trackBy: trackByFn">{{ callout.description | translate }}</p>
      <p *ngIf="callout.correlationId">{{ 'general_error_code' | translate }}: {{ callout.correlationId }}</p>
    </div>
  </div>
</div>
